import { useTranslation } from '@ecomm/i18n'
import { AlarmMoments } from '../index'
import { TabBreakIn } from './TabBreakIn'
import { TabDeliveries } from './TabDeliveries'
import { TabOutdoor } from './TabOutdoor'
import { TabSmokeCo } from './TabSmokeCo'
import { TabTemp } from './TabTemp'
import { TabWater } from './TabWater'

export function USHomePageAlarmMoments() {
  const { t } = useTranslation('alarm-moments')
  const alarmMomentsTabs = [
    {
      label: t('label.outdoor'),
      title: t('title.outdoor'),
      description: t('description.outdoor'),
      tab: <TabOutdoor />
    },
    {
      label: t('label.break-in'),
      title: t('title.break-in'),
      description: t('description.break-in'),
      tab: <TabBreakIn />
    },
    {
      label: t('label.smoke-co'),
      title: t('title.smoke-co'),
      description: t('description.smoke-co'),
      tab: <TabSmokeCo />
    },
    {
      label: t('label.water'),
      title: t('title.water'),
      description: t('description.water'),
      tab: <TabWater />
    },
    {
      label: t('label.temperature'),
      title: t('title.temperature'),
      description: t('description.temperature'),
      tab: <TabTemp />
    },
    {
      label: t('label.deliveries'),
      title: t('title.deliveries'),
      description: t('description.deliveries'),
      tab: <TabDeliveries />
    }
  ] as const

  return <AlarmMoments tabs={alarmMomentsTabs} />
}
